/**
 * The type of recording, which concerns playback and ordering.
 */
export var RecordingType;
(function (RecordingType) {
    /**
     * From a TRM, i.e. written by FTR Gold.
     */
    RecordingType["TRM"] = "trm";
    /**
     * Recorded live from a streaming session.
     */
    RecordingType["Stream"] = "stream";
    /**
     * Recorded locally by realtime recorder and uploaded later.
     */
    RecordingType["LocalCapture"] = "localCapture";
})(RecordingType || (RecordingType = {}));
